/******************************************************************************
 * Copyright (c) 2016 - 2021.                                                 *
 * Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)          *
 * All Rights Reserved.                                                       *
 *                                                                            *
 * The software and data contained herein are confidential and proprietary    *
 * information of Yega Yazilim ("Confidential Information").                  *
 *                                                                            *
 * Users of this software may not disclose such Confidential Information and  *
 * shall use it only in accordance with the terms of the license agreement    *
 * they entered into with Yega Yazilim.                                       *
 *                                                                            *
 * Author:  Ahmet Dogramaci                                                   *
 * Date:    2021-09-27                                                        *
 ******************************************************************************/

import ConfigurationTemplateVersion from "../../business-objects/configuration-template-version";
import QuoteProduct from "../../business-objects/quote-product";
import IsSelected from "../../enums/is-selected";
import YesNo from "../../enums/yes-no";

export default {
    data() {
        let version = new ConfigurationTemplateVersion();
        let product = new QuoteProduct();
        product.configuration_template_version = version;
        return {
            quote_product:product,
            template_version: version,
            IsSelected: IsSelected,
            YesNo: YesNo
        };
    },
    created() {
        this.loadQuoteProduct().then(this.loadTemplate);
    },
    methods: {
        loadQuoteProduct(){
            return this.$store.dispatch('QuoteProductsStore/show', this.$route.params.quote_product_id)
                .then((quote_product_json) => {
                    this.quote_product.buildFromJson(quote_product_json);
                    this.quote_product.detail_attributes_hash_by_cfg_item_id = Object.fromEntries(
                        (quote_product_json.quote_product_details || []).map(detail => [detail.cfg_item_id, {...detail.attribute_store}])
                    );
                })
                .catch((error) => {
                    alert(error.response ? error.response.data : error);
                });
        },
        loadTemplate() {
            let template_id = this.quote_product.cfg_template_id;
            this.$store.dispatch('ConfigurationTemplatesStore/show_all', template_id)
                .then((template_version) => {
                    this.template_version.buildFromJson(template_version);
                    this.template_version.selectNodes(this.quote_product.saved_cfg_item_ids);
                    this.template_version.initialize();
                })
                .catch((error) => {
                    alert(error.response ? error.response.data : error);
                });
        }
    }
}
